<template>
  <div dir="ltr">
    <slick 
    ref="slick" class="sponsers-slick"
    :options="slickOptions">
    <slot></slot>
  </slick>
</div>
</template>

<script>
  import Slick from 'vue-slick';
  export default {
    name: "MerchantsSlider",
    components: { Slick },

    data() {
      return {
        slickOptions: {
          slidesToShow: 7,
          infinite: false,
          dots: false,
          arrows: true,
          dotsClass:'primary-dots transparent-bg-dots slick-dots',
          nextArrow: `<button class="button next-btn has-text-primary" aria-label="Next" type="button">
          <i class="fas fa-caret-right"></i>
          </button>`,
          prevArrow: `<button class="button prev-btn has-text-primary" aria-label="Prev" type="button">
          <i class="fas fa-caret-left"></i>
          </button>`,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
            }
          },
          
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]

  },
};
},
methods: {

},
}
</script>
<style>
.sponsers-slick .slick-dots{
  bottom: -35px;
}
.sponsers-slick{
  margin-bottom:0px;
}
.sponsers-slick .slick-slide{
  border-right:0px;
}
</style>